export default "__VITE_ASSET__BqRVeg$u__"